import { render, staticRenderFns } from "./ShipmentManager.vue?vue&type=template&id=2944531a"
import script from "./ShipmentManager.vue?vue&type=script&lang=js"
export * from "./ShipmentManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports